import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  public constructor(
    private router: Router,
    private authService: AuthService,
    private logger: NGXLogger
  ) {}

  private async hasToken() {
    const token = await this.authService.getToken();
    if (!token) {
      this.logger.error(AuthGuard.name + ' Failed to get token');
      await this.router.navigate(['401']);
    }
    return !!token;
  }

  public async canActivate() {
    return await this.hasToken();
  }

  public canActivateChild() {
    return this.canActivate();
  }

  public async canMatch() {
    return await this.hasToken();
  }
}
